// src/App.tsx
import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, Outlet, useLocation } from "react-router-dom";
import MainLayout from "./UI/layouts/MainLayout";
import Home from "./UI/pages/Home/Home";
import AboutUs from "./UI/pages/About/AboutUs";
import Predicas from "./UI/pages/Predicas/Predicas";
import NewHere from "./UI/pages/NewHere/NewHere";
import Register from "./UI/pages/Register/Register";
import Login from "./UI/pages/Login/Login";
import AvisoPrivacidad from "./UI/pages/AvisoPrivacidad/AvisoPrivacidad";
import Comunicacion from "./UI/pages/Comunicacion/Comunicacion";
import CirculosEstudio from "./UI/pages/CirculosEstudio/CirculosEstudio";
import CodigoFin from "./UI/pages/CirculosEstudio/CodigoFin/CodigoFin";
import AdminRoute from "./routes/AdminRoute";
import AdminLogin from "./UI/pages/AdminLogin/AdminLogin";
import AdminLayout from "./UI/pages/Admin/AdminLayout";
import AdminDashboard from "./UI/pages/Admin/AdminDashboard";
const App: React.FC = () => {

  React.useEffect(() => {
    // Generar un ID único si no existe
    let sessionID = localStorage.getItem("c7_sessionID");
    
    if (!sessionID) {
      sessionID = "c7_" + Math.random().toString(36).substring(2, 10);
      localStorage.setItem("c7_sessionID", sessionID);
    }
  },[])

  function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0
    });
  }, [pathname]);

  return null;
}


  const LayoutWrapper = () => (
    <MainLayout>
      <Outlet />
    </MainLayout>
  );
  
  return (
    <Router>
      <ScrollToTop />
    <Routes>
      <Route element={<LayoutWrapper />}>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/predicas" element={<Predicas />} />
        <Route path="/NewHere" element={<NewHere />} />
        <Route path="/comunicacion" element={<Comunicacion />} />
        <Route path="/register" element={<Register />} />
        <Route path="/login" element={<Login />} />
        <Route path="/privacidad" element={<AvisoPrivacidad />} />
        <Route path="/circulos" element={<CirculosEstudio />} />
      </Route>
      <Route path="*" element={<NotFound />} />

  {/* LOGIN ADMIN */}
  <Route path="/admin-login" element={<AdminLogin />} />

  {/* RUTAS ADMIN PROTEGIDAS */}
  <Route
    path="/admin"
    element={
      <AdminRoute>
        <AdminLayout />
      </AdminRoute>
    }
  >
    <Route index element={<AdminDashboard />} />
  </Route>

  <Route path="*" element={<NotFound />} />


    </Routes>
  </Router>
  );
};
// Componente para la página 404
const NotFound = () => {
  return (
    <div>
      <h1>404 - Página no encontrada</h1>
      <p>
        La página que buscas no existe. <a href="/">Volver al inicio</a>
      </p>
    </div>
  );
};

export default App;
